import createAxiosInstance from '../../../api';
import { useAlert } from '../../../components/Notification';
import { useDispatch } from 'react-redux';
import { setGlobalAlertAction } from '../../../stores/actionTypes/globalAlertActions';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const showAlert = useAlert();
  const dispatch = useDispatch();

  const fetchGlobalAlert = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/globalAlerts', payload)
      .then((response) => {
        dispatch(setGlobalAlertAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setGlobalAlertAction([]));
        showAlert('Failed get Global Alert', 'warning');
      });
    return data;
  };

  const markAsRead = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/customers/markAsRead', payload)
      .then((response) => {
        data = response.data;
      })
      .catch((error) => {
        showAlert(error?.response?.data?.error || error?.message, 'error');
      });
    return data;
  };

  return {
    fetchGlobalAlert,
    markAsRead,
  };
}
